// extracted by mini-css-extract-plugin
export default {"tupacGrid":"El-z","tupacHeader":"Fl-z","tupacHeader2":"Gl-z","tupacMenu":"Hl-z","tupacMenu2":"Il-z","tupacMain":"Jl-z","tupacMain2":"Kl-z"};